import { motion, useMotionValue, useTransform } from "motion/react";
import React, { ReactNode, FC } from "react";
import styled from "@emotion/styled";
import { AnimationConfig } from "./animation.types";

export interface FadeInAnimatorProps {
  children: ReactNode;
  animationConfig?: AnimationConfig;
}

export const FadeInAnimator: FC<FadeInAnimatorProps> = ({ children, animationConfig }) => {
  const duration = (animationConfig?.duration ?? 300) / 1000;
  const delay = (animationConfig?.delay ?? 0) / 1000;

  const opacity = useMotionValue(0);
  const pointerEvents = useTransform(opacity, value => (value > 0.5 ? "auto" : "none"));

  return (
    <StyledMotionDiv
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration, delay, ease: "easeInOut" }}
      style={{ opacity, pointerEvents }}
    >
      {children}
    </StyledMotionDiv>
  );
};

const StyledMotionDiv = styled(motion.div)`
  height: 100%;
  width: 100%;
`;
